import io from 'socket.io-client';
import {AUTHORIZATION_PAYLOAD,} from './helper';

class WebSocketService {
  socket = null;
  connect(url) {
    this.socket = io(url,{
      path: 'socket.io/',
      autoConnect: true,       // Whether to automatically connect (default: true)
      upgrade: false,                 // Disable transport upgrading
      forceNew: true
    });
    this.socket.on('connect', () => {
      console.log('WebSocket connected');
    });
    this.socket.on('disconnect', (reason) => {
      console.log('WebSocket disconnected:', reason);
    });
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  startLinkingAccount(platform, email) {
    if (this.socket) {
      this.socket.emit('startLinkingAccount', {
        platforms: [platform],
        email,
        headers: AUTHORIZATION_PAYLOAD,
      });
    }
  }

  onAccountLinked(callback) {
    if (this.socket) {
      this.socket.on('accountLinked', callback);
    }
  }
}
export default new WebSocketService()
